export enum InteractionState {
  ENABLED = 'enabled',
  PREVIEW = 'preview',
  HOVER = 'hover',
  SELECTED = 'selected',
  DRAG = 'drag',
}
